import(/* webpackMode: "eager" */ "D:\\dev\\project\\bigtv_next\\_asset\\css\\root.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\app\\structure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\components\\popup\\CookieSetComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\bannerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\chatContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\deviceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\LangContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\messageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\moPullingLoad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\navContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\pageTitleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\paramsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefProvider"] */ "D:\\dev\\project\\bigtv_next\\context\\refContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\signContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\siteContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\context\\updateContext.tsx");
;
import(/* webpackMode: "eager" */ "D:\\dev\\project\\bigtv_next\\node_modules\\next\\dist\\client\\script.js");
